import { CommonModuleInner, SectionSubtitle, SectionTitle } from '@/sem/styles';
import type { SemOpenListModule } from '~/contracts/sem';
import GridLayout from './GridLayout';
import ListLayout from './ListLayout';
import SemTrackWrapper from '../SemTrackWrapper';

type OwnProps = Omit<SemOpenListModule, '__typename'>;

// ListLayout for mobile/ GridLayout for desktop
function ShopByMake({ id, subtitle, title, items }: OwnProps) {
  return id && items ? (
    <SemTrackWrapper sectionName="Shop By Make">
      <CommonModuleInner>
        <div className="flex flex-col gap-8 self-start">
          {title && <SectionTitle>{title}</SectionTitle>}
          {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        </div>
        <ListLayout items={items} />
        <GridLayout items={items} />
      </CommonModuleInner>
    </SemTrackWrapper>
  ) : null;
}

export default ShopByMake;
